<template>
  <div class="px-3 py-1">
    <RuleSmallButton
      :title="trans(`subscription.validation_rules.description_add`)"
      type="button"
      class="focus-style btn-secondary my-2"
      @click.native="addRuleProperty()"
    />
  </div>
</template>

<script>
import { RULE_PROPERTY, RULE_TYPE } from '@/constants'
import ruleMixin from '@/employees/components/Rule/utilities/mixins/ruleMixin'
export default {
  name: 'RuleDescriptionAdd',
  mixins: [ruleMixin],
  props: {
    ruleReference: {
      required: true,
      type: String,
    },
  },
  data () {
    return {
      ruleType: RULE_TYPE,
      ruleProperty: RULE_PROPERTY,
    }
  },
  methods: {
    addRuleProperty () {
      this.rulePropertyValueAdd(this.ruleReference, this.ruleProperty.description, this.buildRule(this.ruleType.description))
    },
  },
}
</script>

<style lang="scss" scoped>
.focus-style {
  &:focus {
    border-color: #1b89ff;
    border-width: 1px;
    border-style: solid;
    box-shadow: 0 0 5px rgba(27, 137, 255, .5) !important;
  }
}
</style>
